const styles = theme => ({
  lightTooltip: {
    transform: 'translate3d(0px, -14px, 0px)',
    margin: 4,
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/table/cells/testsRowLink/styles.js